module.exports = __webpack_public_path__ + "img/travelService-new-one.b718eb89.png";